import clsx from "clsx";
import React from "react";

import RatingStar from "../../../molecules/RatingStar";
import { ILessonRetrospectiveScore } from "../../../state";

import style from "./EvaluationLessonModal.module.scss";

export type EvaluationLessonModalProps = {
  defaultEvaluation: ILessonRetrospectiveScore;
  onSubmit: (evaluation: ILessonRetrospectiveScore) => void;
  onClose: () => void;
};

const EvaluationLessonModal: React.FC<EvaluationLessonModalProps> = ({
  defaultEvaluation,
  onSubmit,
  onClose,
}) => {
  const [evaluation, setEvaluation] = React.useState<ILessonRetrospectiveScore>(
    defaultEvaluation,
  );
  const isDirtyData = React.useMemo(() => {
    return (
      !evaluation.understand ||
      !evaluation.sympathize ||
      !evaluation.execute ||
      !evaluation.enjoyed
    );
  }, [evaluation]);

  const update = (args: { [key: string]: any }) => {
    setEvaluation(prevValues => ({ ...prevValues, ...args }));
  };

  return (
    <div className={style.evaluationLesson}>
      <div
        className={style.evaluationLesson__backDrop}
        onClick={() => onClose()}
      />
      <div className={style.evaluationLesson__content}>
        <p className={style.title}>お疲れさまでした。</p>
        <div className={clsx(style.description, "text-center")}>
          <strong>
            今の自分の状態に一番近い項目をチェックして授業を終了しましょう。
          </strong>
          <br />
          <span>
            ※アンケート結果は先生にのみ共有されます。※授業改善のためのアンケートです。評価には関係しません。
          </span>
        </div>
        <div className="row mt-3">
          <div className="col-5" />
          <div className="col-7">
            <div className={style.labels}>
              <span>そう思わない</span>
              <span>そう思う</span>
            </div>
          </div>
        </div>
        <RatingStar
          indexTitle="1"
          title={<>今日の授業が楽しかった</>}
          onRating={index => update({ enjoyed: index })}
          selectedScore={evaluation.enjoyed ?? 0}
        />
        <RatingStar
          indexTitle="2"
          title={<>授業の内容が理解できた</>}
          onRating={index => update({ understand: index })}
          selectedScore={evaluation.understand ?? 0}
        />
        <RatingStar
          indexTitle="3"
          title={
            <>
              授業内の考え方を聞いて
              <br />
              納得した/その通りだと思った
            </>
          }
          onRating={index => update({ sympathize: index })}
          selectedScore={evaluation.sympathize ?? 0}
        />
        <RatingStar
          indexTitle="4"
          title={
            <>
              「自分ならこうしたい」という
              <br />
              具体的な行動が浮かんだ
            </>
          }
          onRating={index => update({ execute: index })}
          selectedScore={evaluation.execute ?? 0}
        />
        <div className={style.commentArea}>
          <p className={style.commentTitle}>
            楽しかったことやもっと聞きたいことなどを先生にコメントしましょう。(任意)
          </p>
          <input
            className={style.commentText}
            type="text"
            value={evaluation.comment ?? ""}
            onChange={e => update({ comment: e.target.value })}
          />
        </div>
        <div className="mt-4 d-flex justify-content-end">
          <button
            className={style.btnSubmit}
            type="button"
            onClick={() => onSubmit(evaluation)}
            disabled={isDirtyData}
          >
            完了
          </button>
        </div>
      </div>
    </div>
  );
};

export default EvaluationLessonModal;
